import { useEffect, useState } from 'react';

import { useRecoilValue } from 'recoil';

import {
  teamEditingRowTeamNameState,
  teamEditingRowEmailState,
  teamEditingRowBackofficeCodeState,
} from 'store';
import { isEmailValid } from 'tools';

export const useTeamCanUpdate = (emailRequired: boolean): boolean => {
  const [canUpdate, setCanUpdate] = useState<boolean>(false);

  const name = useRecoilValue(teamEditingRowTeamNameState);
  const email = useRecoilValue(teamEditingRowEmailState);
  const backofficeCode = useRecoilValue(teamEditingRowBackofficeCodeState);

  const isValidString = (value: string): boolean => {
    return value.length > 0;
  };

  useEffect(() => {
    if (emailRequired) {
      setCanUpdate(
        isValidString(name) && isValidString(backofficeCode) && isEmailValid(email)
      );
    } else {
      setCanUpdate(isValidString(name) && isValidString(backofficeCode));
    }
  }, [name, email, setCanUpdate, emailRequired, backofficeCode]);

  return !canUpdate;
};
